<template>
  <v-card>
    <v-toolbar dark color="#06377a">
      <v-toolbar-title>
        {{
          $attrs.type === "detail"
            ? "Detail Material"
            : "Detail Extend Material"
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn class="mr-1" icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="pt-6">
      <template v-if="$attrs.type !== 'detail'">
        <div class="mb-5">
          <h2>
            {{
              $attrs.type === "detail"
                ? "Detail Material"
                : "Detail Extend Material"
            }}
          </h2>
        </div>

        <div style="width: 100%">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  item-text="description"
                  item-value="plant_code"
                  v-model="plant"
                  :items="list_plant"
                  label="Choose Plant"
                  outlined
                  flat
                  :rules="
                    is_required ? [(v) => !!v || '*Plant is required'] : []
                  "
                  :disabled="this.$attrs.type === 'edit'"
                  clearable
                  @change="getStorageLocation()"
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  item-text="description"
                  item-value="storage_location_code"
                  v-model="storage_location"
                  :items="list_storage_location"
                  label="Choose Storage Location"
                  clearable
                  :rules="
                    is_required
                      ? [(v) => !!v || '*Storage Location is required']
                      : []
                  "
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  item-text="description"
                  item-value="purchasing_group_code"
                  v-model="purchasing_group"
                  :items="list_purchasing_group"
                  label="Choose Purchasing Group"
                  outlined
                  flat
                  clearable
                  :rules="[(v) => !!v || '*Purchasing Group is required']"
                  @change="getDataMrp()"
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  item-text="description"
                  item-value="mrp_type_code"
                  v-model="mrp_type"
                  :items="list_mrp_type"
                  label="Choose MRP Type"
                  clearable
                  :rules="
                    is_required ? [(v) => !!v || '*MRP Type is required'] : []
                  "
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  item-text="description"
                  item-value="mrp_control_code"
                  v-model="mrp_control"
                  :items="list_mrp_control"
                  label="Choose MRP Control"
                  clearable
                  :rules="
                    is_required
                      ? [(v) => !!v || '*MRP Control is required']
                      : []
                  "
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  item-text="description"
                  item-value="mrp_profile_code"
                  v-model="mrp_profile"
                  :items="list_mrp_profile"
                  label="Choose MRP Profile"
                  clearable
                  :rules="
                    is_required
                      ? [(v) => !!v || '*MRP Profile is required']
                      : []
                  "
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-autocomplete
                  item-text="lot_size_procedure_name"
                  item-value="lot_size_procedure_code"
                  v-model="lot_size_procedure"
                  :items="list_lot_size_procedure"
                  label="Choose Lot Size Procedure"
                  clearable
                  :rules="
                    is_required
                      ? [(v) => !!v || '*Lot Size Procedure is required']
                      : []
                  "
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  v-model="old_material_number"
                  label="Enter Old Material Number"
                  outlined
                  flat
                ></v-text-field>
              </v-col>

              <v-col cols="4">
                <v-text-field
                  v-model="remarks"
                  label="Enter Remarks"
                  outlined
                  flat
                ></v-text-field>
              </v-col>

              <!-- <v-col>
            <v-btn
              class="px-5 py-6 mt-1"
              color="success"
              dark
              large
              depressed
              :loading="loading"
              @click="submitMaterial()"
            >
              Extend
            </v-btn>
          </v-col> -->
            </v-row>
          </v-form>
        </div>

        <hr class="mt-5 mb-10" style="border: #dcdcdc 2px dashed;" />
      </template>

      <div class="mb-5">
        <h2>Detail Material</h2>
      </div>

      <v-row>
        <v-col cols="6" class="pl-5 pb-3">
          <div style="display: flex">
            <v-file-input
              v-model="attachment"
              ref="attachment"
              chips
              show-size
              multiple
              style="width: 180px"
              prepend-icon="mdi-file-upload"
              label="Choose File Upload"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xlsx, .xls, .pdf, .jpg, .png, .jpeg, .doc, .docx"
            ></v-file-input>

            <v-btn
              dark
              depressed
              md
              color="primary"
              class="ml-3 mt-5"
              @click="uploadFiles()"
              :loading="loadingUpload"
            >
              Upload
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" class="pb-5">
          <div>
            <MaterialFile
              v-if="!loadingUpload"
              :request_no="data.request_no"
              :material_number="data.material_number"
            ></MaterialFile>

            <div v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="image"
              ></v-skeleton-loader>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Material No.</td>
                  <td class="bold">
                    {{ data.material_number || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Old Material No.</td>
                  <td class="bold">
                    {{ data.old_material_number || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Item Description</td>
                  <td class="bold">
                    <div style="word-break:break-all">
                      {{ data.description || "-" }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Basic Data Text</td>
                  <td class="bold">
                    <div
                      style="word-break:break-all"
                      v-html="basic_data_text_format || '-'"
                    ></div>
                  </td>
                </tr>
                <tr>
                  <td>Colloquial Name</td>
                  <td class="bold">{{ data.colloquial_name || "-" }}</td>
                </tr>
                <tr>
                  <td>Manufacturer</td>
                  <td class="bold">
                    {{ data.manufacturer }} - {{ data.manufacturer_name }}
                  </td>
                </tr>
                <tr>
                  <td>Part Number</td>
                  <td class="bold">
                    {{ data.part_number || "-" }}
                    <span v-if="!data.part_number">-</span>
                  </td>
                </tr>
                <tr>
                  <td>Automatic PO</td>
                  <td class="bold">
                    <v-icon v-if="data.automatic_po === 'X'" color="success">
                      mdi-check-circle
                    </v-icon>

                    <v-icon v-else color="error">
                      mdi-close-circle
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Source List</td>
                  <td class="bold">
                    <v-icon v-if="data.source_list === 'X'" color="success">
                      mdi-check-circle
                    </v-icon>

                    <v-icon v-else color="error">
                      mdi-close-circle
                    </v-icon>
                  </td>
                </tr>
                <tr>
                  <td>Purchasing Group</td>
                  <td class="bold">
                    {{ data.purchasing_group }} -
                    {{ data.purchasing_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>Purchasing Value Key</td>
                  <td class="bold">
                    {{ data.purchasing_value_key }} -
                    {{ data.purchasing_value_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Group</td>
                  <td class="bold">
                    {{ data.mrp_group }} - {{ data.mrp_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Type</td>
                  <td class="bold">
                    {{ data.mrp_type }} - {{ data.mrp_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Control</td>
                  <td class="bold">
                    {{ data.mrp_control }} - {{ data.mrp_control_name }}
                  </td>
                </tr>
                <tr>
                  <td>MRP Profile</td>
                  <td class="bold">
                    {{ data.mrp_profile }} - {{ data.mrp_profile_name }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Category</td>
                  <td class="bold">
                    {{ data.valuation_category }} -
                    {{ data.valuation_category_name }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Type</td>
                  <td class="bold">
                    {{ data.valuation_type || "-" }}
                  </td>
                </tr>
                <tr>
                  <td>Valuation Class</td>
                  <td class="bold">
                    {{ data.valuation_class }} - {{ data.valuation_class_name }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" md="6">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td width="180">Existing Plant</td>
                  <td class="bold">{{ data.plant }} - {{ data.plant_name }}</td>
                </tr>
                <tr>
                  <td>Industry Sector</td>
                  <td class="bold">
                    {{ data.industry_sector }} - {{ data.industry_sector_name }}
                  </td>
                </tr>
                <tr>
                  <td>Material Type</td>
                  <td class="bold">
                    {{ data.material_type }} -
                    {{ data.material_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>Base Unit</td>
                  <td class="bold">
                    {{ data.base_unit }} - {{ data.base_unit_name }}
                  </td>
                </tr>
                <tr>
                  <td>Order Unit</td>
                  <td class="bold">
                    {{ data.order_unit }} - {{ data.order_unit_name }}
                  </td>
                </tr>
                <tr>
                  <td>Division</td>
                  <td class="bold">
                    {{ data.division }} - {{ data.divisi_name }}
                  </td>
                </tr>
                <tr>
                  <td>Material Group</td>
                  <td class="bold">
                    {{ data.material_group }} - {{ data.material_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>External Group</td>
                  <td class="bold">
                    {{ data.external_group }} - {{ data.external_group_name }}
                  </td>
                </tr>
                <tr>
                  <td>Lab/Office</td>
                  <td class="bold">
                    {{ data.lab_office }} - {{ data.lab_office_name }}
                  </td>
                </tr>
                <tr>
                  <td>Basic Material</td>
                  <td class="bold">
                    {{ data.basic_material }} - {{ data.basic_material }}
                  </td>
                </tr>
                <tr>
                  <td>Lot Size Procedure</td>
                  <td class="bold">
                    {{ data.lot_size_procedure }} -
                    {{ data.lot_size_procedure_name }}
                  </td>
                </tr>
                <tr>
                  <td>Procurement Type</td>
                  <td class="bold">
                    {{ data.proc_type }} - {{ data.proc_type_name }}
                  </td>
                </tr>
                <tr>
                  <td>Special Proc.</td>
                  <td class="bold">
                    {{ data.special_proc }} - {{ data.special_proc_name }}
                  </td>
                </tr>
                <tr>
                  <td>Planned Delivery Time</td>
                  <td class="bold">{{ data.planned_delivery_time }} Days</td>
                </tr>
                <tr>
                  <td>Availibility Check</td>
                  <td class="bold">
                    {{ data.availibility_check }} -
                    {{ data.availibility_check_name }}
                  </td>
                </tr>
                <tr>
                  <td>Price Control</td>
                  <td class="bold">
                    {{ data.price_control }} - {{ data.price_control_name }}
                  </td>
                </tr>
                <tr>
                  <td>Storage Location</td>
                  <td class="bold">
                    {{ data.storage_location }} -
                    {{ data.storage_location_name }}
                  </td>
                </tr>
                <tr>
                  <td>Price</td>
                  <td class="bold">
                    {{ data.price_item || "-" }}
                  </td>
                </tr>

                <!-- v-if="$attrs.type === 'detail'" -->
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-action style="background-color: #e7e7e7;">
      <div align="right" class="pa-3">
        <v-btn
          v-if="$attrs.type === 'detail'"
          class="px-5 py-6"
          color="primary"
          dark
          large
          depressed
          :loading="loading"
          @click="closeDialog()"
        >
          Close
        </v-btn>

        <v-btn
          v-else
          class="px-5 py-6"
          color="success"
          dark
          large
          depressed
          :loading="loading"
          @click="processMaterial()"
        >
          {{ $attrs.type === "edit" ? "Save" : "Extend" }}
        </v-btn>
      </div>
    </v-card-action>

    <v-snackbar
      v-model="snackbar.open"
      :timeout="snackbar.timeout ? snackbar.timeout : 7000"
      top
    >
      {{ snackbar.message_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.button_type ? snackbar.button_type : 'primary'"
          v-bind="attrs"
          @click="snackbar.open = false"
        >
          {{ snackbar.button_text ? snackbar.button_text : "Close" }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="notification.open" max-width="350" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ notification.title }}
        </v-card-title>

        <v-card-text>
          {{ notification.text }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="routeList()">
            Oke
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// import StatusVue from "../component/Status.vue"
import MaterialFile from "@/modules//component/MaterialFile.vue"

export default {
  components: { MaterialFile },
  data() {
    return {
      name: "DetailMaterial",
      title: "Detail Material",
      data: null,
      remarks: null,
      plant: null,
      list_plant: [],
      loading: false,
      loadingUpload: false,

      old_material_number: "",
      purchasing_group: "",
      mrp_group: "",
      mrp_type: "",
      mrp_control: "",
      mrp_profile: "",
      lot_size_procedure: "",
      storage_location: "",

      list_purchasing_group: [],
      list_mrp_group: [],
      list_mrp_type: [],
      list_mrp_control: [],
      list_mrp_profile: [],
      list_lot_size_procedure: [],
      list_storage_location: [],

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
      storage_plant: atob(localStorage.getItem("plant_code")),
      snackbar: {
        open: false,
        message_text: null,
        button_type: "primary",
        button_text: "Close",
        timeout: 3000,
      },

      notification: {
        open: false,
        title: null,
        text: null,
      },
      is_required: true,
    }
  },

  computed: {
    basic_data_text_format() {
      return this.data.basic_data_text.replace(/[;]/g, "<br />")
    },
  },

  async mounted() {
    this.plant = this.storage_plant

    await this.getMaterial()
    await this.getPlant()
    await this.getDataDropdown()
    await this.getStorageLocation()
  },

  methods: {
    getMaterial() {
      const self = this
      const id = this.$attrs.data.id
      const type = this.$attrs.type

      var url = this.base_url + "material/getdata/detail_initial_item/" + id

      if (type === "edit") {
        url = this.base_url + "material/getdata/detail/" + id
      }

      this.axios.get(url).then(function(response) {
        self.data = response.data

        if (self.$attrs.type === "edit") {
          self.getDetailEditMaterial()
        }
      })
    },

    async getDetailEditMaterial() {
      const self = this
      self.plant = self.data.plant
      self.purchasing_group = self.data.purchasing_group
      // await self.getDataMrp()
      await self.getStorageLocation()
      await self.getDataMrp()

      self.storage_location = self.data.storage_location
      self.mrp_type = self.data.mrp_type
      self.mrp_control = self.data.mrp_control
      self.mrp_profile = self.data.mrp_profile
      self.lot_size_procedure = self.data.lot_size_procedure
      self.remarks = self.data.remarks
      self.old_material_number = self.data.old_material_number
    },

    async getPlant() {
      const url_dropdown = this.base_url + "master/dropdown/attribute/"
      const url_plant = url_dropdown + "plant/plant_code/"

      const plant = await this.axios.get(url_plant)
      this.list_plant = plant.data ? plant.data : []
    },

    async getDataDropdown() {
      const url_dropdown = this.base_url + "master/dropdown/attribute/"
      const url_purchasing_group =
        url_dropdown + "purchasing_group/purchasing_group_code"

      const url_lot_size_procedure =
        url_dropdown + "lot_size_procedure/lot_size_procedure_code"

      const purchasing_group = await this.axios.get(url_purchasing_group)
      const lot_size_procedure = await this.axios.get(url_lot_size_procedure)

      this.list_purchasing_group = purchasing_group.data
        ? purchasing_group.data
        : []

      this.list_lot_size_procedure = lot_size_procedure.data
        ? lot_size_procedure.data
        : []
    },

    async getDataMrp() {
      const id = this.purchasing_group
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const url_mrp_control =
        url_dropdown + "mrp_control/purchasing_group_code/" + id

      const url_mrp_group =
        url_dropdown + "mrp_group/purchasing_group_code/" + id

      const url_mrp_type = url_dropdown + "mrp_type/purchasing_group_code/" + id

      const url_mrp_profile =
        url_dropdown + "mrp_profile/purchasing_group_code/" + id

      const response_mrp_control = await this.axios.get(url_mrp_control)
      const response_mrp_group = await this.axios.get(url_mrp_group)
      const response_mrp_type = await this.axios.get(url_mrp_type)
      const response_mrp_profile = await this.axios.get(url_mrp_profile)

      this.list_mrp_control = response_mrp_control.data
      this.list_mrp_group = response_mrp_group.data
      this.list_mrp_type = response_mrp_type.data
      this.list_mrp_profile = response_mrp_profile.data

      this.mrp_type = ""
      this.mrp_control = ""
      this.mrp_profile = ""
    },

    async getStorageLocation() {
      const url_dropdown = this.base_url + "master/dropdown/dynamic_attribute/"
      const id = this.plant
      const url = url_dropdown + "storage_location/plant/" + id

      const result = await this.axios.get(url)
      this.list_storage_location = result.data ? result.data : []

      this.is_required = id === "3000" ? false : true

      if (this.$attrs.type === "new") {
        this.purchasing_group = "31P"
        await this.getDataMrp()

        if (this.plant === "3000") {
          this.storage_location = ""
          this.mrp_type = "ND"
          this.mrp_control = ""
          this.mrp_profile = ""
          this.lot_size_procedure = ""
          this.old_material_number = this.data.old_material_number
        } else {
          this.storage_location = "WH01"
          this.mrp_type = "PD"
          this.mrp_control = "CK1"
          this.mrp_profile = "CKZZ"
          this.lot_size_procedure = "EX"
          this.old_material_number = this.data.old_material_number
        }
      }
    },

    async processMaterial() {
      if (this.$attrs.type === "edit") {
        this.editMaterial()
      } else {
        // this.submitMaterial()
        this.sendMaterialSap()
      }
    },

    async submitMaterial(message = null) {
      let url = this.base_url + "material/process/submit"
      let app_status = "CAT"
      let reg_type = "EXT"

      const data = {
        request_by: this.storage_fullname,
        inc_code: "",
        inc_name: "",
        additional_information: "",
        colloquial_name: this.data.colloquial_name
          ? this.data.colloquial_name
          : "",
        material_number: this.data.material_number,
        company: "",
        plant: this.plant,
        industry_sector: this.data.industry_sector.substring(0, 15),
        material_type: this.data.material_type,
        description: this.data.description,
        base_unit: this.data.base_unit,
        division: this.data.division,
        material_group: this.data.material_group,
        external_group: this.data.external_group
          ? this.data.external_group
          : "",
        old_material_number: this.old_material_number || "",
        lab_office: this.data.lab_office ? this.data.lab_office : "",
        basic_data_text: this.data.basic_data_text,
        basic_material: this.data.basic_material
          ? this.data.basic_material
          : "",
        purchasing_group: this.purchasing_group || this.data.purchasing_group,
        order_unit: this.data.order_unit,
        automatic_po: this.data.automatic_po ? "X" : "",
        purchasing_value_key: this.data.purchasing_value_key,
        source_list: this.data.source_list ? "X" : "",
        manufacturer: this.data.manufacturer ? this.data.manufacturer : "",
        part_number: this.data.part_number ? this.data.part_number : "",
        original_part_number: this.data.part_number,
        remarks: this.remarks || "",
        mrp_group: this.data.mrp_group,
        mrp_type: this.mrp_type || this.data.mrp_type,
        mrp_control: this.mrp_control || this.data.mrp_control,
        mrp_profile: this.mrp_profile || this.data.mrp_profile,
        lot_size_procedure:
          this.lot_size_procedure || this.data.lot_size_procedure,
        proc_type: this.data.proc_type,
        special_proc: this.data.special_proc,
        planned_delivery_time: this.data.planned_delivery_time,
        availibility_check: this.data.availibility_check,
        valuation_category: this.data.valuation_category,
        valuation_type: this.data.valuation_type,
        valuation_class: this.data.valuation_class,
        price_control: this.data.price_control,
        storage_location: this.storage_location || this.data.storage_location,
        status: app_status,
        requester: this.storage_user_id,
        cataloguer: "",
        approver: "",
        json_inc_attribute: "",
        requester_description: "",
        requester_additional_info: "",
        requester_json_inc: "",
        type_input: reg_type,
        inserted_by: this.storage_user_id,
        role: this.storage_role,
        user_id: this.storage_user_id,
      }

      if (this.$refs.form.validate()) {
        var self = this
        self.$dialog.confirm({
          text: `${message}. Material cannot be sent to SAP, we will continue the process to the cataloging queue. Are you sure you want to extend this material item ?`,
          title: "Extend Material Item",
          overlay: true,
          actions: {
            false: "No",
            true: {
              color: "primary",
              text: "Yes",
              handle: () => {
                self.loading = true
                try {
                  self.axios.post(url, data).then(function(response) {
                    if (response.status === 200) {
                      self.notification = {
                        open: true,
                        title: "Success",
                        text: "Your material has been successfully extended",
                      }
                      self.$router.push("/listRegister")
                    } else {
                      self.snackbar = {
                        open: true,
                        message_text: response.data.message,
                        button_type: "error",
                      }
                    }
                    self.loading = false
                  })
                } catch (error) {
                  self.loading = false
                  self.snackbar = {
                    open: true,
                    message_text:
                      "Failed process material, please check again your item",
                    button_type: "error",
                  }
                }
              },
            },
          },
        })
      } else {
        this.snackbar = {
          open: true,
          message_text: "field input cannot be empty.",
          button_type: "error",
        }
      }
    },

    async editMaterial() {
      let url = this.base_url + "material/process/update"
      let app_status = "DRAFT_CAT"
      let reg_type = "EXT"

      const id = this.$attrs.data.id

      const data = {
        request_no: this.data.request_no,
        request_by: this.storage_fullname,
        inc_code: "",
        inc_name: "",
        additional_information: "",
        colloquial_name: this.data.colloquial_name
          ? this.data.colloquial_name
          : "",
        material_number: this.data.material_number,
        company: "",
        plant: this.plant,
        industry_sector: this.data.industry_sector,
        material_type: this.data.material_type,
        description: this.data.description,
        base_unit: this.data.base_unit,
        division: this.data.division,
        material_group: this.data.material_group,
        external_group: this.data.external_group
          ? this.data.external_group
          : "",
        old_material_number: this.old_material_number || "",
        lab_office: this.data.lab_office ? this.data.lab_office : "",
        basic_data_text: this.data.basic_data_text,
        basic_material: this.data.basic_material
          ? this.data.basic_material
          : "",
        purchasing_group: this.purchasing_group || this.data.purchasing_group,
        order_unit: this.data.order_unit,
        automatic_po: this.data.automatic_po ? "X" : "",
        purchasing_value_key: this.data.purchasing_value_key,
        source_list: this.data.source_list ? "X" : "",
        manufacturer: this.data.manufacturer ? this.data.manufacturer : "",
        part_number: this.data.part_number ? this.data.part_number : "",
        original_part_number: this.data.part_number,
        remarks: this.remarks || "",
        mrp_group: this.data.mrp_group,
        mrp_type: this.mrp_type || this.data.mrp_type,
        mrp_control: this.mrp_control || this.data.mrp_control,
        mrp_profile: this.mrp_profile || this.data.mrp_profile,
        lot_size_procedure:
          this.lot_size_procedure || this.data.lot_size_procedure,
        proc_type: this.data.proc_type,
        special_proc: this.data.special_proc,
        planned_delivery_time: this.data.planned_delivery_time,
        availibility_check: this.data.availibility_check,
        valuation_category: this.data.valuation_category,
        valuation_type: this.data.valuation_type,
        valuation_class: this.data.valuation_class,
        price_control: this.data.price_control,
        storage_location: this.storage_location || this.data.storage_location,
        status: app_status,
        requester: this.storage_user_id,
        cataloguer: "",
        approver: "",
        json_inc_attribute: "",
        requester_description: "",
        requester_additional_info: "",
        requester_json_inc: "",
        type_input: reg_type,
        inserted_by: this.storage_user_id,
        role: this.storage_role,
        user_id: this.storage_user_id,
        id: id,
      }

      if (this.$refs.form.validate()) {
        var self = this
        self.$dialog.confirm({
          text: "Are you sure you want to process this material item?",
          title: "Extend Material Item",
          overlay: true,
          actions: {
            false: "No",
            true: {
              color: "primary",
              text: "Yes",
              handle: () => {
                self.loading = true
                try {
                  self.axios.post(url, data).then(function(response) {
                    if (response.status === 200) {
                      self.notification = {
                        open: true,
                        title: "Success",
                        text: "Your material has been successfully process",
                      }
                      self.$emit("finishDialog")
                    }
                    self.loading = false
                  })
                } catch (error) {
                  self.loading = false
                  self.snackbar = {
                    open: true,
                    message_text:
                      "Failed process material, please check again your item",
                    button_type: "error",
                  }
                }
              },
            },
          },
        })
      } else {
        this.snackbar = {
          open: true,
          message_text: "field input cannot be empty.",
          button_type: "error",
        }
      }
    },

    closeDialog() {
      this.$emit("closeDialog")
    },

    uploadFiles() {
      if (this.attachment.length === 0) {
        return
      }
      var self = this

      var material_number = this.data.material_number
      let formData = new FormData()
      self.loadingUpload = true

      self.attachment.forEach((file, index) => {
        let name = self.storage_user_id + "-" + file.name
        formData.append(`file${index}`, file)
        formData.append(`filename${index}`, name)
      })

      const filenames = self.attachment.map((file) => file.name)
      formData.append("filenames", JSON.stringify(filenames))
      formData.append("request_number", "")
      formData.append("material_number", material_number)
      formData.append("user_id", self.storage_user_id)

      var url = self.base_url + "material/upload/files"
      self.axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          self.loadingUpload = false
          self.attachment = []

          self.snackbar = {
            open: true,
            message_text: "Material upload has been successful",
            button_type: "primary",
            button_text: "Ok",
          }
        })
        .catch((error) => {
          self.loadingUpload = false

          self.snackbar = {
            open: true,
            message_text: "Material file upload failed",
            button_type: "red",
            button_text: "Ok",
          }

          console("Error upload file" + error)
        })
    },

    sendMaterialSap() {
      const data = {
        request_by: this.storage_fullname,
        inc_code: "",
        inc_name: "",
        additional_information: "",
        colloquial_name: this.data.colloquial_name
          ? this.data.colloquial_name
          : "",
        material_number: this.data.material_number,
        company: "",
        plant: this.plant,
        industry_sector: this.data.industry_sector.substring(0, 15),
        material_type: this.data.material_type,
        description: this.data.description,
        base_unit: this.data.base_unit,
        division: this.data.division,
        material_group: this.data.material_group,
        external_group: this.data.external_group
          ? this.data.external_group
          : "",
        old_material_number: this.old_material_number || "",
        lab_office: this.data.lab_office ? this.data.lab_office : "",
        basic_data_text: this.data.basic_data_text,
        basic_material: this.data.basic_material
          ? this.data.basic_material
          : "",
        purchasing_group: this.purchasing_group || this.data.purchasing_group,
        order_unit: this.data.order_unit,
        automatic_po: this.data.automatic_po ? "X" : "",
        purchasing_value_key: this.data.purchasing_value_key,
        source_list: this.data.source_list ? "X" : "",
        manufacturer: this.data.manufacturer ? this.data.manufacturer : "",
        part_number: this.data.part_number ? this.data.part_number : "",
        original_part_number: this.data.part_number,
        remarks: this.remarks || "",
        mrp_group: this.data.mrp_group,
        mrp_type: this.mrp_type || this.data.mrp_type,
        mrp_control: this.mrp_control || this.data.mrp_control,
        mrp_profile: this.mrp_profile || this.data.mrp_profile,
        lot_size_procedure:
          this.lot_size_procedure || this.data.lot_size_procedure,
        proc_type: this.data.proc_type,
        special_proc: this.data.special_proc,
        planned_delivery_time: this.data.planned_delivery_time,
        availibility_check: this.data.availibility_check,
        valuation_category: this.data.valuation_category,
        valuation_type: this.data.valuation_type,
        valuation_class: this.data.valuation_class,
        price_control: this.data.price_control,
        storage_location: this.storage_location || this.data.storage_location,
        requester: this.storage_user_id,
        cataloguer: "",
        approver: "",
        json_inc_attribute: "",
        requester_description: "",
        requester_additional_info: "",
        requester_json_inc: "",
        inserted_by: this.storage_user_id,
        role: this.storage_role,
        user_id: this.storage_user_id,
      }

      var text = "Are you sure, you want send to SAP this item ?"

      if (this.$refs.form.validate()) {
        this.$dialog.confirm({
          text: text,
          title: `Send to SAP`,
          overlay: true,
          actions: {
            false: "No",
            true: {
              color: "primary",
              text: "Yes",
              handle: () => {
                var self = this
                var url = self.base_url + "material/sap/submit"
                self.loading = true

                self.axios
                  .post(url, data)
                  .then(function(response) {
                    if (response.status === 200) {
                      var data = response.data
                      var sap_callback = data.result
                        ? data.result.ABM_MMM_112_MT_MATERIAL_DATA_RESPONSE
                        : ""

                      if (sap_callback.material_number) {
                        self.notification = {
                          open: true,
                          title: "Succesfully sent to SAP",
                          text: sap_callback.message,
                          color: "primary",
                        }

                        self.getMaterial()
                      }

                      if (sap_callback.message) {
                        self.loading = false
                        self.submitMaterial(sap_callback.message)
                      } else {
                        self.loading = false
                        self.snackbar = {
                          open: true,
                          message_text: data.message,
                          button_type: "error",
                        }
                      }
                    }
                  })
                  .catch(function() {
                    self.loading = false
                    const message =
                      "Failed process send material to sap, error connection server"

                    self.submitMaterial(message)

                    // self.snackbar = {
                    //   open: true,
                    //   message_text: message,
                    //   button_type: "error",
                    // }
                  })
              },
            },
          },
        })
      } else {
        this.snackbar = {
          open: true,
          message_text: "field input cannot be empty.",
          button_type: "error",
        }
      }
    },
  },
}
</script>

<style>
.bold {
  font-weight: 600 !important;
}
</style>
